import axios from "axios";
import { Loading, Notify } from "notiflix";
import { APIURL } from "./config";
import { TICKET_DETAILS, TICKET_LIST } from "./types";

export const getTicketList = () => async dispatch => {

  const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: {}
  };
  try {
    Loading.standard();
    const res = await axios.get(`${APIURL}/api/entity/ticket/fetch/list`, config);
    Loading.remove();
    if (res?.data?.status) {
      dispatch({ type: TICKET_LIST, payload: res?.data?.body })
    } else if (!res?.data?.status) {
      dispatch({ type: TICKET_LIST, payload: [] });
    } else if (res?.data?.message) {
      Notify.warning(res?.data?.message);
    } else {
      Notify.warning("something went wrong");
    }
  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? 'internal server error'
    Notify.failure(message);
  }
}

export const createTicket = (data, cb) => async dispatch => {

  const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
  try {
    Loading.standard();
    const res = await axios.post(`${APIURL}/api/entity/ticket/create`, data, config);
    Loading.remove();
    if (res?.data?.status) {
      const message = res?.data?.message ? res?.data?.message : "Ticket added successfully!"
      Notify.success(message);
      dispatch(getTicketList());
      if (cb) cb();
    } else if (res?.data?.message) {
      Notify.warning(res?.data?.message);
    } else {
      Notify.warning("something went wrong");
    }
  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? 'internal server error'
    Notify.failure(message);
  }
}

export const getTicketDetails = (params) => async dispatch => {

  const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: {}
  };
  const queryString = typeof (params) === 'object' ? Object.keys(params).map(key => `${key}=${params[key]}`).join('&') : '';
  try {
    Loading.standard();
    const res = await axios.get(`${APIURL}/api/entity/ticket/action/fetch/customer/list?${queryString}`, config);
    Loading.remove();
    if (res?.data?.status) {
      dispatch({ type: TICKET_DETAILS, payload: res?.data?.body })
    } else if (!res?.data?.status) {
      dispatch({ type: TICKET_DETAILS, payload: [] });
    } else if (res?.data?.message) {
      Notify.warning(res?.data?.message);
    } else {
      Notify.warning("something went wrong");
    }
  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? 'internal server error'
    Notify.failure(message);
  }
}

export const postTicketAction = (data, cb) => async dispatch => {

  const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
  try {
    Loading.standard();
    const res = await axios.post(`${APIURL}/api/entity/ticket/action/create`, data, config);
    Loading.remove();
    if (res?.data?.status) {
      const message = res?.data?.message ? res?.data?.message : "Ticket action posted successfully!"
      Notify.success(message);
      if (cb) cb();
    } else if (res?.data?.message) {
      Notify.warning(res?.data?.message);
    } else {
      Notify.warning("something went wrong");
    }
  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? 'internal server error'
    Notify.failure(message);
  }
}